import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {BehaviorSubject} from 'rxjs'
import {distinctUntilChanged, map, tap} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {TokenStorage} from './token-storage';
import {Router} from '@angular/router';
// import {LoaderService} from '../service/loader.service';
import jwt_decode from 'jwt-decode';
import { of } from 'rxjs';

// const apiUrl = environment.baseAPIUrl;

interface State {
  data: any;
  authenticated: boolean;
}

const defaultState: State = {
  data: null,
  authenticated: Boolean(TokenStorage)
};

const store = new BehaviorSubject<State>(defaultState);

class Store {
  private store = store;
  changes = this.store.asObservable().pipe(distinctUntilChanged());

  setState(state: State) {
    this.store.next(state);
  }

  getState(): State {
    return this.store.value;
  }

  updateState(data: State) {
    this.store.next(Object.assign({}, this.getState(), data));
  }

  purge() {
    this.store.next(defaultState);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private store: Store = new Store();
  public authenticated: boolean = false;
  uname = '';

  constructor(private http: HttpClient, private jwt: TokenStorage, private router: Router) {
    this.store.setState({
      data: null, authenticated: Boolean(this.jwt.get())
    });
  }

  isAuthenticated(): Observable<any> {
    if (!this.jwt.get()) {
      return of(null);
    } else {
      return of(Boolean(this.jwt));
    }
  }

  verifyAuth(): Observable<any> {
    if (!this.jwt.get()) {
      return of(null);
    } else {
      return of(Boolean(this.jwt));
    }
  }

  attempAuth(uname: string, password: string): Observable<any> {
    this.uname = uname;
    return of(null)
  }

  b2cAttemptAuth(data:any): Observable<any>{
    this.jwt.save(data);
    this.authenticated = Boolean(data);
    return of (
      this.store.setState({
        data: data, authenticated: Boolean(data)
      })
    )
  }
  //Method to store refresh token
  saveRefreshToken(data: any): Observable<any> {
    // localStorage.setItem('REFRESH_TOKEN', data);
    this.jwt.saveRT(data);
    // this.authenticated = Boolean(data);
    return of(
      this.store.setState({
        data: data, authenticated: Boolean(data)
      })
    )
  }

  //Method to get user details from login token
  getDecodedAccessToken(token: string): any {
    try {         
      return jwt_decode(token);     
    } catch(Error){
      return null;     
    }   
  }

  getAuthState() {
    return this.store.getState();
  } 

  logoutUser() {
    this.store.setState({
      data: null, authenticated: false
    });
    return of (
      this.store.setState({
        data: null, authenticated: false
      })
    )
  }
}
